import React from 'react';

function SpaceViewDetails({ space, t }) {
    const trList = (v) =>
        Array.isArray(v) && v.length
            ? v.map((x) => t(x)).join(", ")
            : t("Unknown");

    const trField = (v) => {
        if (typeof v === 'string' && v.trim() !== '') return t(v);
        if (v !== undefined && v !== null && v !== '') return String(v);
        return t('Unknown');
    };

    return (
        <div className="space-view-left-side left-side-content">
            {/* Description */}
            <div className="space-data-block space-details">
                <div className="space-view-data-title space-description-title">{t("Description")}</div>
                <div className="space-view-data-text space-description-text">{space.description}</div>
            </div>

            {/* Basic Info */}
            <div className="space-data-block space-basic-info">
                <div><strong>{t("Floors")}:</strong> {trField(space.floors)}</div>
                <div><strong>{t("Square Meters")}:</strong> {trField(space.squareMeters)}</div>
                <div><strong>{t("Building Type")}:</strong> {trList(space.building_type)}</div>
            </div>

            {/* Construction */}
            <div className="space-data-block space-construction">
                <div className="space-view-data-title space-description-title">{t("Building Details")}</div>
                <div className="space-view-data-block">
                    <strong>{t("Roof")}:</strong>
                    <div className="space-view-data">{t("Material")}: {trList(space.roof?.material)}</div>
                    <div className="space-view-data">{t("State")}: {trField(space.roof?.condition)}</div>
                </div>
                <div className="space-view-data-block">
                    <strong>{t("Walls")}:</strong>
                    <div className="space-view-data">{t("Material")}: {trList(space.walls?.material)}</div>
                    <div className="space-view-data">{t("State")}: {trField(space.walls?.condition)}</div>
                </div>
                <div className="space-view-data-block">
                    <strong>{t("Coating")}:</strong>
                    <div className="space-view-data">{t("Material")}: {trList(space.coating?.material)}</div>
                    <div className="space-view-data">{t("State")}: {trField(space.coating?.condition)}</div>
                </div>
                <div className="space-view-data-block">
                    <strong>{t("Openings")}:</strong> {trList(space.openings)}
                </div>
                <div>
                    <strong>{t("Accessibility")}:</strong> {trList(space.access)}
                </div>
            </div>

            {/* Extras */}
            <div className="space-data-block space-extras">
                <div className="space-view-data-title space-description-title">{t("Extra Details")}</div>
                <div><strong>{t("Includes")}:</strong> {trList(space.includes)}</div>
                <div><strong>{t("Notes")}:</strong> {space.extraNotes}</div>
            </div>
        </div>
    );
}

export default SpaceViewDetails;
